"use client";
import { deepMerge } from "../../utils/deep-merge/deep-merge.mjs";
import { defaultCssVariablesResolver } from "./default-css-variables-resolver.mjs";
//#region packages/@mantine/core/src/core/MantineProvider/MantineCssVariables/get-merged-variables.ts
function getMergedVariables({ theme, generator }) {
	const defaultResolver = defaultCssVariablesResolver(theme);
	const providerGenerator = generator?.(theme);
	return providerGenerator ? deepMerge(defaultResolver, providerGenerator) : defaultResolver;
}
//#endregion
export { getMergedVariables };

//# sourceMappingURL=get-merged-variables.mjs.map